import React from 'react';
import PropTypes from 'prop-types';
import {NextSeo} from 'next-seo';
import {useRouter} from 'next/router';

const SITE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : 'https://22-cat-fe.dev.3si.vn';

const defaultSep = ' | ';

const isUrl = (str) => {
  let pattern = new RegExp(
    '^(https?:\\/\\/)?' +
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
      '((\\d{1,3}\\.){3}\\d{1,3}))' +
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
      '(\\?[;&a-z\\d%_.~+=-]*)?' +
      '(\\#[-a-z\\d_]*)?$',
    'i',
  );
  return !!pattern.test(str);
};

const AppPage = ({children, ...rest}) => {
  const router = useRouter();
  let {
    title,
    description,
    image,
    category = 'cong-an-thanh-pho-hue',
    tags = ['cong-an', 'cong-an-thanh-pho-hue'],
    slug,
    url,
  } = rest;

  if (router && router.asPath.includes('/bai-viet/')) {
    slug = router.asPath.replaceAll('/bai-viet/', '');
  }

  const defaultTitle = 'CÔNG AN THÀNH PHỐ HUẾ';
  const defaultDescription = 'TRANG THÔNG TIN ĐIỆN TỬ CÔNG AN THÀNH PHỐ HUẾ';
  const defaultImage = '/assets/images/banner/banner-1.png';
  const defaultImageApi = image
    ? image
    : `${process.env.SITE_URL}/api/metadata/${slug}?image=true`;
  const theTitle = title
    ? title?.length > 48
      ? title.replace(
          /^(\w)(.+)/,
          (match, p1, p2) => p1.toUpperCase() + p2.toLowerCase(),
        )
      : title.replace(
          /^(\w)(.+)/,
          (match, p1, p2) => p1.toUpperCase() + p2.toLowerCase(),
        ) +
        defaultSep +
        defaultTitle
    : defaultTitle;
  const theDescription = description
    ? description.substring(0, 155)
    : defaultDescription;
  const theImage = image
    ? isUrl(image)
      ? image
      : `${SITE_URL}${image}`
    : defaultImage;

  return (
    <React.Fragment>
      <NextSeo
        title={title}
        description={theDescription}
        canonical={url ? url : process.env.SITE_URL}
        openGraph={{
          url: url ? url : process.env.SITE_URL,
          title: title,
          description: theDescription,
          type: 'website',
          images: [
            {
              url: !!slug ? defaultImageApi : theImage,
              width: 800,
              height: 600,
              alt: title,
              type: 'image/*',
            },
            {
              url: !!slug ? defaultImageApi : theImage,
              width: 900,
              height: 800,
              alt: title,
              type: 'image/*',
            },
          ],
          site_name: 'CÔNG AN THÀNH PHỐ HUẾ',
        }}
        tags={tags}
        category={category}
      />
      {children}
    </React.Fragment>
  );
};

export default AppPage;

AppPage.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  slug: PropTypes.string,
};
